export default "__VITE_ASSET__D$v2WJ_J__"